// Content for the HanDu landing page and privacy policy.
//
// Everything here is checked against the iOS app's source rather than written
// as marketing copy — the file paths in the comments are the receipts.

// Mirrors Legal in HanDu/DesignSystem/LegalFooter.swift, which is the app's
// single source of truth for these two strings.
export const legal = {
  copyright: '© 2026 Yusuf Brigui',
  contactEmail: 'briguiyoussef2005@icloud.com',
  privacyEffective: '14 August 2026',
}

// Swap `url` in for the real App Store listing once App Store Connect issues
// it; the hero renders a link instead of a static badge as soon as it's set.
export const appStore = {
  available: true,
  url: "https://apps.apple.com/app/handu-%E6%B1%89%E8%AF%BB/id6801454925",
  label: 'Download from App Store',
}

export const features = [
  {
    title: 'Tap a word',
    body: 'Any word opens its pinyin and meaning in place, without leaving the page or losing your spot.',
  },
  {
    title: 'Or tap for the sentence',
    body: 'Switch to sentence mode and a tap gives you the whole line in English, plus every word in it.',
  },
  {
    title: 'Pinyin on or off',
    body: 'Read with pinyin under each word while you build confidence, then turn it off. Nothing reflows.',
  },
  {
    title: 'Categorized library',
    body: 'Texts are labelled beginner, intermediate, or advanced, filterable by level and tagged by topic.',
  },
  {
    title: 'Mark what you finish',
    body: 'Mark a text as read and it moves to your profile. Change your mind and unmark it just as easily.',
  },
  {
    title: 'Your progress follows you',
    body: 'Sign in with email or with Apple, and what you have read is there on every device you use.',
  },
]

// Seeded reader demo. Shaped like the app's Token model
// (HanDu/Models/AppModels.swift) so the page's reader and the real one are
// driven by the same idea of a token.
export const demoSentence = {
  translation: 'I am going to the library today to read.',
  tokens: [
    { hanzi: '我', pinyin: 'wǒ', translation: 'I; me' },
    { hanzi: '今天', pinyin: 'jīntiān', translation: 'today' },
    { hanzi: '去', pinyin: 'qù', translation: 'to go; to go to' },
    { hanzi: '图书馆', pinyin: 'túshūguǎn', translation: 'library' },
    // `trailing` rides along with the word rather than being its own token, so
    // the full stop can never wrap onto a line by itself.
    { hanzi: '看书', pinyin: 'kàn shū', translation: 'to read (a book)', trailing: '。' },
  ],
}

// The card shape the library renders, from HanDu/Views/Library/LibraryView.swift.
export const demoLibraryCards = [
  {
    level: 'Beginner',
    title: "Anna's Family",
    description: 'Anna introduces her family',
    category: 'family',
  },
  {
    level: 'Intermediate',
    title: 'Modern Career and Perseverance',
    description: 'Reflections on job hunting and perseverance in modern society',
    category: 'Society',
  },
]

export const faq = [
  {
    q: 'Does tapping translate one word, or the whole sentence?',
    a: "Whichever you prefer. Translation Mode has two settings — Word and Sentence — and you can change it in two places. Settings sets your default for every text. Reading Options inside a text changes it for that text only, unless you choose “Save as my default”, which makes it stick everywhere.",
  },
  {
    q: 'Do I have to read with pinyin above the characters?',
    a: 'No. Writing System switches between Hanzi + Pinyin and Hanzi only, and it applies immediately — including to a text you already have open, so you can drop the pinyin mid-paragraph the moment you no longer need it and pick it back up if a sentence gets away from you.',
  },
  {
    q: 'Why does HanDu need an account?',
    a: 'So your reading progress is yours rather than the phone’s: which texts you have finished is stored against your account and is there when you sign in somewhere else. You can create one with an email and password or use Sign in with Apple. Deleting your account from Settings removes it and all of your progress permanently.',
  },
]
